import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "@/pages/Home";
import AuthCallback from "@/pages/AuthCallback";
import Archive from "@/pages/Archive";
import Admin from "@/pages/Admin";
import { Toaster } from "sonner";
import "@/App.css";

function AppRouter() {
  const location = useLocation();
  // Handle Emergent OAuth callback (session_id in URL fragment) before other routes.
  if ((location.hash || window.location.hash || "").includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/play/:caseId" element={<Home />} />
      <Route path="/archive" element={<Archive />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppRouter />
      <Toaster position="top-center" richColors closeButton={false} />
    </BrowserRouter>
  );
}
